import { attr, belongsTo } from "@ember-data/model";
import dayjs from "dayjs";
import {
  validateDate,
  validatePresence
} from "ember-changeset-validations/validators";
import type IntlService from "ember-intl/services/intl";
import JournalEvent from "parog-web/models/journal-event";
import type Patient from "parog-web/models/patient";
import { setupNames } from "parog-web/utils/person";
import tWithDefault from "parog-web/utils/t-with-default";
import type ReferentLabUpdatedJournalEvent from "./referent-lab-updated-journal-event";

const CareGiverRoles = [
  "historicNurse",
  "relative",
  "psad",
  "pharmacist",
  "medicalDoctor",
  "psychiatrist",
  "diabetologist-endocrinologist",
  "psychologist",
  "physiotherapist",
  "analistique-laboratory",
  "radiotherapist",
  "surgeon",
  "gynecologist",
  "doctor",
  "nurse",
  "caregiver",
  "analistique-laboratory",
  "attending-surgeon",
  "analistique-laboratory",
  "acupuncturist",
  "administrative",
  "algologist",
  "anaesthetist",
  "angiologist",
  "anatomopathologist",
  "social-worker",
  "association",
  "cardiologist",
  "pathway-coordinator",
  "dietician",
  "endocrinologist",
  "gynecologist",
  "homeopath",
  "hypnotherapist",
  "magnetizer",
  "esthetics-and-laser-doctor",
  "geriatrician-doctor",
  "nuclear-doctor",
  "naturopath",
  "nephrologist",
  "nutritionist",
  "oncologist",
  "osteopath",
  "pulmonologist",
  "radiologist",
  "reflexologist",
  "midwife",
  "surgery-secretariat",
  "oncology-secretariat",
  "sexologist",
  "socio-esthetician",
  "sophrologist",
  "dermograph-tattooer",
  "provider",
  "dental-surgeon",
  "nurse-coordinator",
  "announcement-nurse",
  "mim",
  "biologist",
  "private-nurse",
  "other"
];
export { CareGiverRoles };

//---- Automatically generated, don't update this part ----

export default class CareGiverAddedJournalEvent extends JournalEvent {
  static override type = "care-giver-added-journal-event";

  @attr("string") declare firstName: string;

  @attr("string") declare lastName: string;

  @attr("string") declare phone: string;

  @attr("string") declare email: string;

  @attr("string") declare address: string;

  @attr("string") declare role: string;

  @belongsTo("referent-lab-updated-journal-event", {
    async: false,
    inverse: "careGiverAddedJournalEvent"
  })
  declare referentLabUpdatedJournalEvent: ReferentLabUpdatedJournalEvent;

  static override validations(intl: IntlService) {
    return {
      lastName: validatePresence({
        presence: true,
        description: intl.t(
          "validations.care-giver-added-journal-event.last-name"
        )
      }),
      role: validatePresence({
        presence: true,
        description: intl.t("validations.care-giver-added-journal-event.role")
      }),
      occurredAt: [
        validatePresence({
          presence: true,
          description: tWithDefault(
            intl,
            "validations.care-giver-added-journal-event.occurred-at",
            "La date"
          )
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée avant 1900. Veuillez modifier la date",
          onOrAfter: new Date("01/01/1900")
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée dans le futur. Veuillez modifier la date",
          onOrBefore: dayjs().endOf("day").toDate()
        })
      ]
    };
  }

  //---- End of generated code ----

  get fullName() {
    return setupNames([this.firstName, this.lastName]);
  }

  get isValidLaboratory(): boolean {
    return this.role == "analistique-laboratory" && Boolean(this.phone);
  }

  @belongsTo("patient", {
    async: false,
    inverse: "careGiverAddedJournalEvents"
  })
  declare patient: Patient;
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module "ember-data/types/registries/model" {
  export default interface ModelRegistry {
    "care-giver-added-journal-event": CareGiverAddedJournalEvent;
  }
}
